import React from 'react';

// Style modernisé & sobre (charte navy #242166). Cartes KPI compactes, tableaux denses,
// en-tête épuré. Plus de colonnes bénéficiaires → pas de scroll horizontal inutile.
const StatistiquesSAPStyle = () => {
    return (
        <style>{`
            .sap-page-header {
                background: linear-gradient(135deg, #242166 0%, #3d3a8f 100%);
                border-radius: 14px;
                padding: 20px 28px;
                margin-bottom: 18px;
                box-shadow: 0 6px 20px rgba(36, 33, 102, 0.22);
            }
            .sap-page-header .header-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                gap: 12px;
            }
            .sap-page-header h1 {
                color: #fff;
                font-size: 22px;
                font-weight: 700;
                margin: 0 0 4px 0;
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .sap-page-header p {
                color: rgba(255,255,255,0.82);
                font-size: 13px;
                margin: 0;
            }

            .filters-card {
                border-radius: 12px;
                box-shadow: 0 1px 4px rgba(0,0,0,0.06);
                margin-bottom: 16px !important;
            }
            .filters-card .ant-card-body { padding: 14px 16px; }
            .filter-item label {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 11px;
                font-weight: 600;
                color: #6b7280;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                margin-bottom: 6px;
            }

            /* Cartes KPI compactes */
            .stat-card {
                border-radius: 12px;
                box-shadow: 0 1px 4px rgba(0,0,0,0.06);
                border: 1px solid #eef0f4;
                transition: box-shadow 0.2s ease, transform 0.2s ease;
            }
            .stat-card .ant-card-body { padding: 14px 18px; }
            .stat-card:hover {
                box-shadow: 0 4px 14px rgba(36,33,102,0.10);
                transform: translateY(-1px);
            }
            .stat-card .ant-statistic-title { font-size: 12px; color: #6b7280; margin-bottom: 2px; }
            .stat-card .ant-statistic-content { font-size: 22px; }
            .stat-card-highlight {
                background: linear-gradient(135deg, #f5f4ff 0%, #efeeff 100%);
                border: 1px solid #d7d5f5;
            }

            /* Tableaux denses */
            .ant-table-thead > tr > th {
                background: #f7f7fb !important;
                font-weight: 600;
                font-size: 12px;
                color: #374151;
            }
            .ant-table-tbody > tr > td { font-size: 13px; }
            .ant-table-tbody > tr:hover > td { background: #fafaff !important; }

            .ant-tabs-tab { font-weight: 500; }
            .ant-tabs-tab-active { font-weight: 600; }

            @media (max-width: 768px) {
                .sap-page-header .header-content { flex-direction: column; align-items: flex-start; }
                .sap-page-header { padding: 18px 20px; }
                .sap-page-header h1 { font-size: 19px; }
            }
        `}</style>
    );
};

export default StatistiquesSAPStyle;
